export default {
  clientid: "126de00a-e599-4933-aaf2-22d0fe45b8f5",
  //clientid: "33355bb0-eee1-45fc-9ecd-938d2b7ad45a",
  authority:
  // "https://whitecape.b2clogin.com/tfp/whitecape.onmicrosoft.com/B2C_1_identity_provider/",
  // authorityForgotPassword: "https://whitecape.b2clogin.com/tfp/whitecape.onmicrosoft.com/B2C_1_FORGOT_PASSWORD/"
    "https://mescytportal.b2clogin.com/tfp/mescytportal.onmicrosoft.com/B2C_1_identity_provider/",
  authorityForgotPassword: "https://mescytportal.b2clogin.com/tfp/mescytportal.onmicrosoft.com/B2C_1_FORGOT_PASSWORD/"
  //"https://B2Clogin.com/tfp/whitecape.onmicrosoft.com/B2C_1_identity_provider/v2.0/"
  //"https://whitecape.b2clogin.com/whitecape.onmicrosoft.com/v2.0" 
  // "https://login.microsoftonline.com/tfp/whitecape.onmicrosoft.com/B2C_1_identity_provider/v2.0/"
};